import { SearchStockLedgerParams, StockLedgerFilter } from './types'

/** BE `MAX_PAGE_SIZE` 와 동일 — 초과 요청은 서버가 캡핑하므로 처음부터 상한으로 요청한다. */
export const STOCK_LEDGER_MAX_PAGE_SIZE = 10000

/** 조회 페이지 지정 — 1-base 페이지와 크기. 엑셀은 주지 않는다(서버가 page/pageSize 를 무시하고 전량 최대 100,000행). */
export interface StockLedgerPaging {
  page: number
  pageSize: number
}

/** 엑셀 다운로드 사유 — 다운로드 사유 모달(1.0 RemarkPop 동치)에서 받는다. */
export interface StockLedgerDownloadReason {
  reasonCode: string
  reasonDetail: string
}

/**
 * 1.0 grid/search 호환 페이로드를 만든다 — body 는 `{ "params": "<stringified JSON>" }` 한 겹이다.
 *
 * 조회/엑셀이 같은 페이로드를 쓴다(엑셀은 page/pageSize 를 서버가 무시하고 전량 최대 100,000행).
 * USR_ID 는 인자로 받는다 — BE 감사로그는 인증 컨텍스트(SecurityUtil)를 쓰므로 echo 용이지만
 * 1.0 페이로드 형식 호환으로 채워 보낸다.
 *
 * `reason`(엑셀 사유)은 페이로드 최상위에 함께 싣는다 — BE 가 받아 EXPORT 접근로그 remark 에
 * `{사유코드}_{상세사유}`(상세사유가 없으면 사유코드만) 로 저장한다 (LOGISPRD-15466). 조회 페이로드에는 싣지 않는다.
 */
export const buildStockLedgerPayload = (
  filter: StockLedgerFilter,
  userId: string,
  reason?: StockLedgerDownloadReason,
  paging: StockLedgerPaging = { page: 1, pageSize: STOCK_LEDGER_MAX_PAGE_SIZE },
): GridApiRequestBody => {
  const params: SearchStockLedgerParams & Partial<StockLedgerDownloadReason> = {
    MENU_CD: 'ST03_HEAD',
    USR_ID: userId,
    params: filter,
    type: 'SEARCH',
    page: paging.page,
    pageSize: paging.pageSize,
    ...reason,
  }

  return { params: JSON.stringify(params) }
}
